import React from "react";

import appleTv from "../../../resources/apple_tv.png";

import type { JSX } from "react";

interface IAppleTvIcon {
  className?: string;
}

function AppleTvIcon(props: IAppleTvIcon): JSX.Element {
  const { className } = props;
  return <img alt="apple-tv-icon" className={className} src={appleTv} />;
}

export default AppleTvIcon;
